

import React, { useEffect } from "react";
import "../../../styles/products-styling/cleaned/product.css";
import HeaderComponent from "./headerComponent";
import SectionComponent from "./sectionComponent";

export default function StoreCreditRefundsComponent() {
    return (
        <div
            className=""
        >
            <HeaderComponent />
            <SectionComponent />
        </div>
    );
};

